<template>
    <v-dialog ref="dateDialog" v-model="modal" :return-value.sync="date" persistent :width="dialogWidth">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="date" :label="label" :prepend-icon="icon" :rules="rules" :color="color" readonly v-bind="attrs" v-on="on">
            </v-text-field>
        </template>
        <v-date-picker v-model="date" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal = false">{{cancelBtn}}</v-btn>
            <v-btn text color="primary" @click="$refs.dateDialog.save(date)">{{okBtn}}</v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
export default {
  name: "RyouDate",
  props: {
    dialogWidth: {
      type: String,
      required: false,
      default: "290px"
    },
    label: {
      type: String,
      required: false,
      default: "日付選択"
    },
    icon: {
      type: String,
      required: false,
      default: "mdi-calendar"
    },
    color: {
      type: String,
      required: false,
      default: ""
    },
    cancelBtn: {
      type: String,
      required: false,
      default: "Cancel"
    },
    okBtn: {
      type: String,
      required: false,
      default: "OK"
    },
    value: {
      type: String,
      required: false,
      default: new Date().toISOString().substr(0, 10)
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      modal: false
    };
  },
  computed: {
    date: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {},
  methods: {}
  //   model: {
  //     prop: "value",
  //     event: "change"
  //   }
};
</script>

<style scoped>
</style>
